<template>
    <div class="flex flex-col items-center">
        <div class="mb-3 w-32 h-32">
            <user-avatar :avatar-url="avatarUrl" :username="user.name" size="lg"></user-avatar>
        </div>
        <div class="flex justify-around">
            <my-button id="pick-avatar" class="btn btn-line rounded-full btn-sm mx-auto">
                <span v-if="avatarUrl">Change your avatar...</span>
                <span v-else><i class="fa fa-upload"></i> Upload your avatar...</span>
            </my-button>
        </div>
        <a v-if="avatarUrl" href="#" class="text-xs mt-2 underline" @click.prevent="removeAvatar"
            >Remove my avatar and show my user initials instead</a
        >

        <avatar-cropper
            trigger="#pick-avatar"
            :upload-url="`/api/users/${user.id}/update-avatar`"
            output-mime="image/jpeg"
            :upload-headers="{ 'X-CSRF-TOKEN': csrfToken(), accept: 'application/json' }"
            :labels="{ submit: 'Upload', cancel: 'Cancel' }"
            class="text-gray-700"
            mimes="image/png, image/jpeg"
            @uploading="handleUploading"
            @uploaded="handleUploaded"
            @completed="handleCompleted"
            @error="handleError"
        />
    </div>
</template>

<script>
import Errors from '../../forms/errors';

export default {
    components: {
        'avatar-cropper': () => import(/* webpackChunkName: "lazy-loaded/vue-avatar-cropper" */ 'vue-avatar-cropper')
    },

    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loader: false,
            avatarUrl: this.user.avatar_url
        };
    },

    methods: {
        handleUploading() {
            NProgress.inc();
        },

        handleUploaded(response) {
            this.avatarUrl = response.data.avatar;
            flash.success();
        },

        handleCompleted() {
            NProgress.done();
        },

        handleError(message, type, xhr) {
            if (xhr.status === 422) {
                let errors = new Errors(JSON.parse(xhr.responseText).errors);
                flash.error({ message: errors.get('file') });
                return;
            }

            flash.error();
        },

        removeAvatar() {
            if (!confirm('Are you sure you want to remove your avatar?')) {
                return;
            }

            axios.delete(`/api/users/${this.user.id}/avatar`).then(() => {
                flash.success();
                this.avatarUrl = null;
            });
        }
    }
};
</script>
